var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.5 2.5c.1 1.1-.3 2.1-.9 2.9-.7.8-1.7 1.4-2.7 1.3-.1-1.1.4-2.2 1-2.9.7-.8 1.9-1.4 2.6-1.3zM19.8 17.2c-.4 1-.9 1.9-1.6 2.8-.9 1.2-1.9 2.6-3.3 2.6-1.2 0-1.6-.8-3-.8-1.4 0-1.9.8-3 .8-1.3 0-2.4-1.5-3.3-2.7-1.8-2.5-3.2-7.1-1.3-10.2.9-1.5 2.6-2.5 4.3-2.5 1.3 0 2.4.9 3.1.9.7 0 2.1-1.1 3.6-.9.6 0 2.4.2 3.5 1.9-3 1.8-2.5 6 .9 8.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkApple);
export default __webpack_public_path__ + "static/media/link-apple.5e0481496b903f122c0735885aea0a97.svg";
export { ForwardRef as ReactComponent };